import { Page } from '@/pages/AdvancedEditor/AdvancedEditor';
import { useAdvancedEditorContext } from '@/pages/AdvancedEditor/context/useAdvancedEditorContext';
import { PolotnoStoreActivePageKeys, setPageProperty, usePolotnoActivePageState } from '@/pages/AdvancedEditor/hooks';
import { CacheStatus } from '@/pages/AdvancedEditor/hooks/useUploadTtsCache';
import { useEffect } from 'react';
import { useMutation } from 'react-query';
import { useLocation } from 'react-router-dom';
import { useEffectEvent } from 'use-effect-event';
import { deleteTtsCache } from '../api';

export const useTtsCacheManagement = () => {
    const [ttsAudioCacheStatus] = usePolotnoActivePageState(PolotnoStoreActivePageKeys.ttsAudioCacheStatus);
    const { mutateAsync: deleteTtsCacheMutation } = useMutation(deleteTtsCache, { retry: true });

    const { store } = useAdvancedEditorContext();

    const { pathname } = useLocation();
    const projectId = pathname.split('/').pop() ?? '';
    const activeSceneId = store.activePage?.id;

    // https://react.dev/learn/separating-events-from-effects
    const onCacheStatusChange = useEffectEvent(
        ({ currentActiveSceneId, currentProjectId, page }: { currentActiveSceneId: string; currentProjectId: string; page: Page }) => {
            deleteTtsCacheMutation({ projectId: currentProjectId, sceneId: currentActiveSceneId }).then(() => {
                setPageProperty(page, PolotnoStoreActivePageKeys.ttsAudioCacheStatus)(CacheStatus.Empty);
                setPageProperty(page, PolotnoStoreActivePageKeys.ttsCreated)(false);
            });
        }
    );

    useEffect(() => {
        if (ttsAudioCacheStatus !== CacheStatus.Invalid || !activeSceneId) return;
        onCacheStatusChange({
            currentActiveSceneId: activeSceneId,
            currentProjectId: projectId,
            page: store.activePage,
        });
    }, [activeSceneId, onCacheStatusChange, projectId, ttsAudioCacheStatus]);
};
